var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":_vm.transition}},[_c('popper',_vm._g(_vm._b({ref:"tf-tooltip",class:{ 'with-close': _vm.showClose },on:{"show":function($event){_vm.showTooltip = _vm.showClose}}},'popper',{
      ..._vm.$attrs,
      ..._vm.$props,
      forceShow: _vm.forceShow || _vm.showTooltip
    },false),_vm.$listeners),[_c('div',{staticClass:"tf-popper tf-tooltip wt-popper wt-tooltip",class:_vm.customClass},[_c('div',[_vm._t("default")],2),(_vm.showClose)?_c('TfButton',{staticClass:"btn-popper-close",style:({
          top: `${_vm.closePosition.top}px`,
          right: `${_vm.closePosition.right}px`
        }),attrs:{"icon":"times","size":"icon-no-fill","type":"primary","no-padding":"","data-test":"close tooltip"},on:{"click":function($event){return _vm.$refs['tf-tooltip'].doClose()}}}):_vm._e()],1),_c('template',{slot:"reference"},[_vm._t("reference")],2)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }